// @flow
import { Grid } from 'semantic-ui-react';
import React from 'react';
import { CommittedCapacityAddMetricRowContainerForEstimateCC } from '@components/committed-capacity/CommittedCapacityAddMetricRowContainerForEstimateCC';

export const AddNewMetricRowRelatedRowForEstimateCC = ({ metricDimensionRefs, row }) => (
  <Grid.Row>
    <Grid.Column width={3}>
      <CommittedCapacityAddMetricRowContainerForEstimateCC
        dimensionsArrayHelpers={
          metricDimensionRefs.current.dimensionArrayHelpersMap[row.metricName]
        }
        metricRow={row}
      />
    </Grid.Column>
  </Grid.Row>
);
